import {StorageUtils} from "xmgoing-utils";
import {message, UploadChangeParam} from "ant-design-vue";
import {ref} from "vue";
import {getFileList} from "@/components/fileCtl/api/file";

/**
 * 加载附件列表集合
 * @param businessId
 */
const loadFileList = async function (businessId: string,fileList:any) {
  if (businessId == null || businessId === "") {
    return;
  }
  const res = await getFileList(businessId);
  if(res&&Array.isArray(res.records)&&res.records.length>0){
    res.records.forEach((itemDb)=>{
      itemDb.name=itemDb.fileName;
    })
    fileList.value=res.records;
  }else{
    fileList.value=[];
  }
};

export function useBaseCommFile(businessId,changeInput){
  //获取当前用户的token
  const token = StorageUtils.getSessionItem("sessionId");
  const headers = {
    "Blade-Auth": `bearer ${token}`,
    'Page-Code':StorageUtils.getSessionItem("pageCodeValue"),
    Authorization: `Basic c2FiZXI6c2FiZXJfc2VjcmV0`,
  };

  const loading=ref(false);

  const fileList = ref([]);
  /**
   * 上传成功后执行
   * @param info
   */
  const handleChange = (info: UploadChangeParam) => {
    if (info.file.status === 'uploading') {
      return;
    }
    if (info.file.status === 'done') {
      changeInput({});
      loadFileList(businessId,fileList);
      loading.value = false;
    }
    if (info.file.status === 'error') {
      loading.value = false;
      message.error('upload error');
    }
  }

  if(businessId&&businessId.length>0){
    loadFileList(businessId,fileList);
  }

  return {
    loadFileList,
    fileList,
    loading,
    uploadAction:`/api/pe-attachment/attachment/upload`,
    handleChange,
    headers
  }
}
